import React from 'react';

const CheckAvailabilityForm = ({ status, productId, handleCheckSubmit, quantity, setQuantity }) => {
    console.log('productId', productId);
    return (
        <div className='card px-2 py-4 h-100' style={
            status === 'available' ? { backgroundColor: '#b3f7b0' } : (
                status === 'not available' ? { backgroundColor: '#f7b0cb'} : (
                    status === 'Invalid Quantity' ? { backgroundColor: '#fadb93'} : {})
            )
        }>
            <p className='display-6'>
                <small>Check Availability by Quantity &nbsp;&nbsp;
                    {productId ? <i className='h6'>for Product ID: {productId} </i> : null}
                </small>
            </p>
            <form className="form-inline" onSubmit={handleCheckSubmit}>
                <div className="form-group mb-2">
                    <label htmlFor="productQuantity" className="sr-only mb-2">Product Quantity</label>
                    <input 
                        value={quantity} 
                        onChange={(e) => setQuantity(e.target.value)} 
                        type="number" className="form-control" 
                        id="productQuantity" 
                        placeholder="Enter Quantity" 
                        required
                    />
                </div>
                <button type="submit" className="btn btn-primary my-2">Check Availability</button>
            </form>
            <p className='text-center display-6'>{status}</p>
        </div>
    );
};

export default CheckAvailabilityForm;